import { Suspense, useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { Button, Skeleton } from '@/components/ui'
import { ListaUltimosAtendimentos, ListaUltimosAtendimentosSkeleton } from '@/features/atendimento/components'
import { ConsulteEmpreendimentosHero } from '@/features/atendimento/components/consulte-empreendimentos-hero'
import { usePrefetchEmpreendimentos } from '@/features/empreendimentos/hooks/use-prefetch-empreendimentos'
import { usePrefetchRegionais } from '@/features/regionais/hooks/use-prefetch-suspense-regionais'
import { PageLayout } from '@/layouts/page'

export const UltimosAtendimentosPage = () => {
  const { t } = useTranslation('atendimento')
  const prefetchRegionais = usePrefetchRegionais()
  const prefetchEmpreendimentos = usePrefetchEmpreendimentos()
  const navigate = useNavigate()

  useEffect(() => {
    prefetchRegionais()
    prefetchEmpreendimentos()
  }, [])

  const handleNavigateToConsultaLeadsRepresados = () => {
    navigate('/leads-represados')
  }

  return (
    <PageLayout className="mx-auto min-h-screen w-full py-6 sm:max-w-4xl" data-testid="home-page">
      <div className="bg-foreground px-6 py-8 sm:max-w-4xl">
        <div className="@container">
          <ConsulteEmpreendimentosHero />
          <div className="mb-6 flex flex-wrap items-center justify-between gap-4 md:flex-nowrap">
            <h3 className="text-xl font-normal text-gray-600 uppercase">
              {t('pages.ultimos_atendimentos.titulo_lista')}
            </h3>
            <Button onClick={handleNavigateToConsultaLeadsRepresados} className="font-nunito w-full md:w-56">
              {t('pages.ultimos_atendimentos.botoes.consulta_leads')}
            </Button>
          </div>
          <Suspense fallback={<ListaUltimosAtendimentosSkeleton />}>
            <ListaUltimosAtendimentos />
          </Suspense>
        </div>
      </div>
    </PageLayout>
  )
}

export const UltimosAtendimentosPageSkeleton = () => {
  return (
    <div className="bg-foreground mx-auto px-6 py-8 sm:max-w-4xl" data-testid="ultimos-atendimentos-skeleton">
      <ConsulteEmpreendimentosHero />
      <div className="mb-6 flex items-center justify-between">
        <Skeleton className="h-7 w-58" />
        <Skeleton className="h-10 w-56 rounded-md" />
      </div>
      <ListaUltimosAtendimentosSkeleton />
    </div>
  )
}
